import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { fontSize } from "@/components/signup/utils/font-size";

export const Separator = ({ separatorText }: { separatorText?: string }) => {
    const intl = useIntl();

    if (separatorText === undefined) {
        separatorText = intl.formatMessage({
            id: "BxpUiSignup.SignupForm.or",
            defaultMessage: "Or continue with"
        });
    }

    return (
        <div css={separatorCss}>
            <div css={separatorBorder} />
            {separatorText}
            <div css={separatorBorder} />
        </div>
    );
};

const separatorBorder = css({
    borderColor: "inherit",
    borderStyle: "solid",
    borderWidth: 0.125,
    display: "block",
    flexGrow: 1,
    height: 0,
    margin: "0 1rem",
    opacity: 0.25
});

const separatorCss = css({
    fontSize: fontSize.sm,
    display: "flex",
    lineHeight: ".25px",
    margin: "2rem 0",
    textAlign: "center"
});
